import { render, staticRenderFns } from "./ArchiveWarehouseUsers.vue?vue&type=template&id=71bdd03e&"
import script from "./ArchiveWarehouseUsers.vue?vue&type=script&lang=js&"
export * from "./ArchiveWarehouseUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveWarehouseUsers.vue"
export default component.exports